import { Calendar1, Clock, Copy, Ticket, User, UserCheck, Users } from "lucide-react";
import PageHeader from "../components/Header";
import { useAppContext } from "../context/appContext";
import { eventInfoApi, isUserLoggedInApi, signOutApi } from "../apis/authService";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Divider from "../components/Divider";
import Button from "../components/Button";
import { extractDataFromArray, logoutCookies, timeFormatter } from "../utils/utils&validatation";
import Loader from "../components/Loader";
import Tooltip from "../components/Tooltip";

const StatusOptions = [
    { key: "total_invited", icon: <Users color={"#155dfc"} style={{ width: "32px", height: "32px" }} />, text: "Total invited", bgcolor: "#b1c0f9" },
    { key: "total_attended", icon: <UserCheck color={"#00a63e"} style={{ width: "32px", height: "32px" }} />, text: "Total attended", bgcolor: "#b1f9be" },
    { key: "duplicates", icon: <Copy color={"#d08700"} style={{ width: "32px", height: "32px" }} />, text: "Duplicate entries", bgcolor: "#f0d972" },
    { key: "remaining", icon: <Clock color={"#e7000b"} style={{ width: "32px", height: "32px" }} />, text: "Pending check ins", bgcolor: "#fdc9db" },
];

const StatusCard = ({ data }) => {
    return (
        <div
            className="flex g-8 justify-center"
            style={{
                flexWrap: "wrap",
                // justifyContent: "center",
                backgroundColor: "inherit"
            }}
        >
            {StatusOptions.map(({ key, icon, text, bgcolor }) => (
                <div
                    className="w-full flex col-flex justify-center items-center br-8 g-4"
                    key={key}
                    style={{
                        // maxWidth: "177px",
                        // minWidth: "30%",
                        width: "45%",
                        height: "70pxpx",
                        backgroundColor: bgcolor,
                        border: "1px solid #e2e7f1",
                        padding: "24px 2px",
                        // gap: "2px",
                    }}
                >
                    {icon}
                    <div className="inherit-bgcolor flex col-flex items-center g-3">
                        <p className="font-sm m-0 inherit-bgcolor">{text}</p>
                        <b className="font-sm m-0 inherit-bgcolor">{data[key]}</b>
                    </div>
                </div>
            ))}
        </div>
    );
};

const Status = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const {
        // selected,
        // setSelected,
        totalCheckedIn,
        setTotalCheckedIn
    } = useAppContext();

    // const parsedEvent = selected?.event;

    const [isLoggedIn, setIsLoggedIn] = React.useState("checking");
    const [eventInfo, setEventInfo] = React.useState({
        event: "",
        time: "",
        total_invited: 0,
        total_attended: 0,
        duplicates: 0,
        remaining: 0,
    });
    const [disabled, setDisabled] = React.useState(null);

    const handleLogout = React.useCallback(async () => {
        try {
            const res = await signOutApi({ cmd: "signOut" });
            if (extractDataFromArray(res, ["errorCode"], 1) == 0) {
                logoutCookies();
                navigate("/event-scanner/login");
            }
        } catch (err) {
            console.error("Error inside signOutApi =>", err)
        }
    }, [navigate]);

    // Check login status
    React.useEffect(() => {
        const fetchUserStatus = async () => {
            try {
                const res = await isUserLoggedInApi({ cmd: "isUserLoggedIn" });

                if (extractDataFromArray(res, ["errorCode"], "") !== 1) {
                    window.user_info = extractDataFromArray(res, ["data"], {});
                    setIsLoggedIn("logged-in");
                } else {
                    setIsLoggedIn("logged-out");
                }
            } catch (err) {
                console.log("Error in isUserLoggedInApi:", err);
                setIsLoggedIn("logged-out");
            }
        };

        fetchUserStatus();
    }, []);

    React.useEffect(() => {
        if (isLoggedIn === "logged-out") {
            handleLogout();
        }
    }, [isLoggedIn, handleLogout]);

    // React.useEffect(() => {
    //     if (isLoggedIn !== "logged-in") return;
    //     // if (!parsedEvent) navigate("/event-scanner/event-slots");
    // }, [isLoggedIn,
    //     // parsedEvent,
    //     navigate
    // ]);

    React.useEffect(() => {
        if (isLoggedIn !== "logged-in") return;

        const loadEventInfo = async () => {
            try {
                const response = await eventInfoApi({
                    cmd: "fetchIndividualEvent",
                    event_id: id,
                    // event: parsedEvent === "NA" ? "" : parsedEvent,
                    // start_time: selected.start_time,
                    // end_time: selected.end_time || "",
                });

                if (response?.errorCode === 1) {
                    setDisabled("errorApi");
                    setTotalCheckedIn("0/0");
                    return;
                }

                const { event, total_allowed, total_checked_in, duplicate_entries } = response.data;

                setDisabled("pass");
                setEventInfo({
                    event: event === "" ? "NA" : event,
                    time: timeFormatter(response?.data),
                    total_invited: total_allowed,
                    total_attended: total_checked_in,
                    duplicates: duplicate_entries,
                    remaining: total_allowed - total_checked_in,
                });
                setTotalCheckedIn(`${total_checked_in}/${total_allowed}`);
            } catch (err) {
                console.log("EventInfoApi error:", err);
            }
        };

        loadEventInfo();
    }, [isLoggedIn, setTotalCheckedIn, id,]);

    if (disabled === null) {
        return <Loader />;
    }

    if (disabled === "errorApi") {
        return (
            <div className="w-full"
                style={{
                    border: "1px solid #fafafc",
                    backgroundColor: "#f9fafb",
                    height: "100vh",

                }}>
                <PageHeader />
                <Divider />
                <div className="w-full flex col-flex justify-center items-center g-8" style={{ minHeight: "calc(100% - 73px)" }}>
                    <img src="https://qrcodechimp.s3.amazonaws.com/sysconf/no_event.svg" style={{ width: "65%", margin: "0 auto" }} alt="no_event.svg" />
                    <p style={{ fontSize: "20px" }}>No event ticket found</p>
                    <Button
                        onClick={() => {
                            // setSelected({ event: "", time: "" });
                            // localStorage.setItem("selected", JSON.stringify({ event: "", time: "" }));
                            // window.selected = ({ event: "", time: "" });
                            navigate("/event-scanner/event-slots");
                        }}
                        buttonText="Go back"
                    />
                </div>
            </div>
        );
    }

    return (
        <div
            className="w-full h-full flex col-flex"
            style={{
                border: "1px solid #e2e7f1",
                backgroundColor: "#f9fafb",
            }}
        >
            <PageHeader />
            <Divider />

            {/* event info */}

            <div
                className="flex col-flex justify-center br-8 bc-white w-auto h-auto g-3"
                style={{
                    padding: "8px 16px",
                    border: "1px solid #e2e7f1",
                    margin: "12px 16px",
                }}
            >
                <div className="flex items-center g-2 p-1">
                    <Ticket style={{ width: 20, height: "auto", flexShrink: 0, }} className="mr-2" />
                    <Tooltip content={eventInfo.event}>
                        <p
                            className="font-sm flex items-center"
                            style={{
                                height: "max-content",
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                                cursor: "default",
                            }}
                        >
                            Event: <b>{eventInfo.event}</b>
                        </p>
                    </Tooltip>
                </div>

                {eventInfo?.time !== "NA" && (
                    <div className="flex items-center g-2 p-1">
                        <Calendar1 style={{ width: 20, height: "auto", flexShrink: 0, }} className="mr-2" />
                        <Tooltip content={eventInfo.time}>
                            <p
                                className="font-sm flex items-center"
                                style={{
                                    height: "max-content",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 1,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    wordBreak: "break-word",
                                    whiteSpace: "normal",
                                    cursor: "default",
                                }}
                            >
                                Slot: <b>{eventInfo.time}</b>
                            </p>
                        </Tooltip>
                    </div>
                )}

                <div className="flex items-center g-2 p-1">
                    <User style={{ width: 20, height: "auto", flexShrink: 0, }} className="mr-2" />
                    <p
                        className="flex items-center font-sm"
                        style={{
                            height: "max-content",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                        }}
                    >
                        Total checked-in: <b>{totalCheckedIn}</b>
                    </p>
                </div>
            </div>
            <Divider />

            <div className="bc-white" style={{ flex: 1, padding: "20px" }}>
                <StatusCard data={eventInfo} />
            </div>
        </div>
    );
};

export default Status;